export async function checkSession() {
    try {
        const res = await fetch('/api/session', { credentials: 'include' })
        const data = await res.json()
        return !!data.authenticated
    } catch (e) {
        return false
    }
}

export async function logout() {
    try {
        await fetch('/api/logout', { method: 'POST', credentials: 'include' })
    } catch (e) {
        // ignore network errors; the client-side state is cleared by navigating to /login regardless
    }
}
